<template>
  
    <el-container>
     
      <el-main>
       <h1>Relate node with annotation</h1>
        <h3>Method 1</h3>

        <p>Use <i> obsidian://jump-to-pdf</i> protocol </p>
        <ul>
            <li>Open <i>jump-to-pdf</i> protocol in setting tab</li>
            <li>Automatic create PDF annotation reference link and copy to clipboard when click pdf-annotate</li>
            <li>paste to markdown file</li>
        </ul>

        <h3>Method 2</h3>
        <p>If you select markdown to save pdf annotations in setting tab</p>
        <ul>
            <li>you can use <i>[[${md name}#${block reference}]]</i> to associate quote block with a block reference.</li>
            <li>An obsidian link to an annotation block-reference will, when clicked, open the corresponding file and scroll to the associated highlight. If the file is already open in a pane, then the link will cause the existing pane to scroll instead.</li>
        </ul>

        <div>
            <img src="../assets/markmind/annotate.gif" alt="" width="800">
        </div>
        <div>
            <img src="../assets/markmind/annotate1.gif" alt="" width="800">
        </div>

      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'relatePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
